import addIceCandidate from './addIceCandidate'
import addTrack from './addTrack'
import close from './close'
import createAnswer from './createAnswer'
import createOffer from './createOffer'
import findReusableTransceiver from './findReusableTransceiver'
import getState from './getState'
import getStats from './getStats'
import removeTrack from './removeTrack'
import replaceTrack from './replaceTrack'
import sendDTMF from './sendDTMF'
import setLocalDescription from './setLocalDescription'
import setRemoteDescription from './setRemoteDescription'
import setTransceiversDirection from './setTransceiversDirection'

const methods = {
  addIceCandidate,
  addTrack,
  close,
  createAnswer,
  createOffer,
  findReusableTransceiver,
  getState,
  getStats,
  removeTrack,
  replaceTrack,
  sendDTMF,
  setLocalDescription,
  setRemoteDescription,
  setTransceiversDirection
}

export default methods
